import {EventBus} from './event-bus'
import {HashMap} from "@/utils/HashMap";
import {eventCollect} from "@/services/event";

let eventList = new HashMap();

let currentPage = {}
let flows = [
  {name: '换电柜编辑',
    page: "ChargeCabinet",
    events: [{name: "showEdit"}, {name: "edit"}]},
  {name: '运营商编辑', page: "operator", events: [{name: "edit"}, { page: "editOperation",name: "commit"}]},
  {
    name: '运营商新增', page: "operator", events: [{name: "add"}, { page: "AddOperation",name: "commit"}]}
];

let startIdleTime = 0;
let totalIdleTime = 0;

EventBus.$on("collect-query", (data) => {
  if(!data.that.getSearchData){
         return;
  }
   let params=data.that.getSearchData();

//  let params={...data.params};
  Object.keys(params).forEach(key=>{
    if(!params[key]){
      delete params[key];
      return;
    }
    if(Array.isArray(params[key]) && params[key].length==0){
      delete params[key];
      return;
    }

  });

  if( Object.keys(params).length==0){
    return;
  }
  let route = data.route;
  let pageName = (route.meta && route.meta.title) ? route.meta.title : route.name;
  eventCollect({eventType: 4, pagePath: route.path, pageName: pageName,pageTag:data.label,queryParams:JSON.stringify(params)})
});



//事件点击
EventBus.$on("collect", (data) => {

  let route = data.route;
    let eventName = data.page + "-" + data.label;
   let pageName = (route.meta && route.meta.title) ? route.meta.title : route.name;
    eventList.put(eventName, new Date().getTime());
    flows.forEach(item => {
      let itemEventName = (item.events[item.events.length - 1].page?item.events[item.events.length - 1].page:item.page) + "-" + item.events[item.events.length - 1].name;
      if (eventName == itemEventName) {
        let startEventName =(item.events[0].page?item.events[0].page:item.page) + "-" + item.events[0].name;
        let start = eventList.getValue(startEventName);
        eventCollect({flowName:item.name,eventType: 3, pagePath: route.path, totalTime: new Date().getTime() - start, pageName: pageName})

      //  console.log(`流程名:${item.name} 用时：${new Date().getTime() - start}`)
      }
    });
    eventCollect({eventType: 2, pagePath: route.path, pageName: pageName,pageTag:data.label,btnName:data.name})
  }
)
EventBus.$on("startPage", (data) => {
  startIdleTime=0;
  currentPage = {...data, startTime: new Date().getTime()};
})
EventBus.$on("endPage", (data) => {
  endPage(data)
})


EventBus.$on("pageIdle", (data) => {
  //空闲
  if (data.isIdle) {
    //startIdleTime=new Date().getTime()-30*1000*60;//记录开始空闲的时间
    startIdleTime = new Date().getTime() - 10 * 60 * 1000;//记录开始空闲的时间
  } else {
    if (startIdleTime) {
      totalIdleTime += (new Date().getTime() - startIdleTime);
    }
  }
});


//页面离开事件
export function endPage(route) {
  let idleTime = totalIdleTime;
  totalIdleTime = 0;
  startIdleTime = 0;
  let totalTime = new Date().getTime() - currentPage.startTime - idleTime;
  let pageName = (route.meta && route.meta.title) ? route.meta.title : route.name
  eventCollect({eventType: 1, pagePath: route.path, totalTime: totalTime, pageName: pageName})


}



// WEBPACK FOOTER //
// ./src/utils/collectUtil.js